



















































































































































































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import QrcodeVue from 'qrcode.vue'
import {MixinScreenSize} from './mixins/MixinScreenSize'
import ConnectWalletModal from '@/components/walletConnection/ConnectWalletModal.vue'
import {$} from '@/facade'
import {isNeoLineInAppBrowser} from '@/store/model/wallets/connection/NeoLineConnection'

@Component({
  components: {
    ConnectWalletModal,
    QrcodeVue,
  },
})
export default class SessionButton extends Mixins(MixinScreenSize) {
  @Prop({type: Boolean, default: false, required: false}) forceLarge!: boolean

  n3TruncatedAddress: string | null = null
  neoXTruncatedAddress: string | null = null

  dropdownSessionIsOpen = false

  /** Inside the NeoLine in-app browser, disconnecting N3 is not offered. */
  get isNeoLineInApp() {
    return isNeoLineInAppBrowser()
  }

  created() {
    this.onN3AddressChange($.walletAdapter.n3Address)
    this.onNeoXAddressChange($.walletAdapter.xAddress)
  }

  toggleModalSession() {
    this.dropdownSessionIsOpen = !this.dropdownSessionIsOpen
  }

  async disconnectN3Address() {
    $.walletAdapter.disconnectN3Wallet()
  }

  async disconnectNeoXAddress() {
    $.walletAdapter.disconnectXWallet()
  }

  connectNeoXAddress() {
    $.modal.open('connectWalletModal')
  }

  connectN3Address() {
    $.modal.open('connectWalletModal')
  }

  openModal() {
    $.modal.open('connectWalletModal')
  }

  @Watch('$store.state.walletAdapter.n3.address')
  onN3AddressChange(address: string | null) {
    this.n3TruncatedAddress = address?.trim()
      ? `${address.trim().slice(0, 5)}...${address.trim().slice(-4)}`
      : null
  }

  @Watch('$store.state.walletAdapter.neoX.address')
  onNeoXAddressChange(address: string | null) {
    this.neoXTruncatedAddress = address?.trim()
      ? `${address.trim().slice(0, 5)}...${address.trim().slice(-4)}`
      : null
  }
}
